/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkImportError
 */
export interface BulkImportError {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof BulkImportError
     */
    parse: { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof BulkImportError
     */
    validation: { [key: string]: Array<string>; };
    /**
     * 
     * @type {boolean}
     * @memberof BulkImportError
     */
    database: boolean;
}

/**
 * Check if a given object implements the BulkImportError interface.
 */
export function instanceOfBulkImportError(value: object): value is BulkImportError {
    if (!('parse' in value) || value['parse'] === undefined) return false;
    if (!('validation' in value) || value['validation'] === undefined) return false;
    if (!('database' in value) || value['database'] === undefined) return false;
    return true;
}

export function BulkImportErrorFromJSON(json: any): BulkImportError {
    return BulkImportErrorFromJSONTyped(json, false);
}

export function BulkImportErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportError {
    if (json == null) {
        return json;
    }
    return {
        
        'parse': json['parse'],
        'validation': json['validation'],
        'database': json['database'],
    };
}

export function BulkImportErrorToJSON(json: any): BulkImportError {
    return BulkImportErrorToJSONTyped(json, false);
}

export function BulkImportErrorToJSONTyped(value?: BulkImportError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parse': value['parse'],
        'validation': value['validation'],
        'database': value['database'],
    };
}

